export default __webpack_public_path__ + "static/media/Alak-Modak.fee7f699.pdf";